import ActionNode from './ActionNode'

class ActionNodeWebhook extends ActionNode {
  constructor(model) {
    super(model)
    this.text = `Post contact info to ${model.value.url || ''}`
    this.icon = {
      ...this.icon,
      name: 'global'
    }
  }

  changeValue(value) {
    this.value = value
    this.text = `Post contact info to ${value.url || ''}`
  }
}

export default ActionNodeWebhook



// WEBPACK FOOTER //
// ./src/utils/models/node/ActionNodeWebhook.js